import axios from 'axios';

// On-demand Q2 (AI summarization) requests.
//
// These reach a desktop in Brian's house, which this app cannot address: the
// request is dropped in an SQS queue by the API and long-polled from there by
// the Librarian daemon. So a 200 here means "queued", never "done" -- the work
// itself lands minutes later and is observed by polling `q2_state`, which
// arrives back over database replication.
//
// Staff-only, enforced server-side by IsAdminUser. The is_staff checks in this
// app are cosmetic and hide UI; they are not the gate.
const q2Api = axios.create({ baseURL: `${process.env.REACT_APP_API_URL}/q2` });

q2Api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Token ${token}`;
  return config;
});

// Ask for specific fixtures by id.
export const requestFixtures = (fixtureIds) =>
  q2Api.post('/request/', { fixture_ids: fixtureIds });

// Ask for a whole league-day. The set is resolved SERVER-side, against the same
// league-day window the slate itself uses, so the count the button reports and
// the games the page shows cannot drift apart.
export const requestDay = (league, date, onlyUnprocessed = true) =>
  q2Api.post('/request/', { league, date, only_unprocessed: onlyUnprocessed });

// Per-fixture lifecycle state for one league-day. Deliberately tiny: it is
// polled every few seconds while work is in flight.
export const getStatus = (league, date) =>
  q2Api.get('/status/', { params: { league, date } });

export default q2Api;
